module.exports = __webpack_public_path__ + "static/img/A6103_.5f75046d.png";